"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MoreIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { className: props.color, d: "M12.5 7C13.875 7 15 5.875 15 4.5C15 3.125 13.875 2 12.5 2C11.125 2 10 3.125 10 4.5C10 5.875 11.125 7 12.5 7ZM12.5 9.5C11.125 9.5 10 10.625 10 12C10 13.375 11.125 14.5 12.5 14.5C13.875 14.5 15 13.375 15 12C15 10.625 13.875 9.5 12.5 9.5ZM12.5 17C11.125 17 10 18.125 10 19.5C10 20.875 11.125 22 12.5 22C13.875 22 15 20.875 15 19.5C15 18.125 13.875 17 12.5 17Z" })));
};
exports.default = MoreIcon;
